import { createSlice } from "@reduxjs/toolkit";
import { spaceCreate } from "./spaceAsyncThunk";

const spaceCreateSlice = createSlice({
  name: "space",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [spaceCreate.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [spaceCreate.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [spaceCreate.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default spaceCreateSlice.reducer;
